import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { SpaceCostTypeName, VenueFeatures, VenueSpace } from "sweet-global";
import GuestsIcon from "sweet-web/components/icons/GuestsIcon";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import Input from "sweet-web/components/universal/Input";
import CostInput from "sweet-web/components/universal/Input/CostInput";
import MultiSelectInput from "sweet-web/components/universal/Input/MultiSelectInput";
import { Indent } from "sweet-web/components/universal/View";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;
`;

const emptySpace: VenueSpace = {
  name: "",
  startingCost: {
    amount: null,
    currency: "USD",
    type: "HOUR"
  },
  capacity: null,
  features: [],
  description: ""
};

type Props = {
  spaceId?: string;
  spaceEntity?: VenueSpace;
  onSave: (space: VenueSpace) => void;
  onCancel: () => void;
};

const EditSpace: React.FC<Props> = props => {
  const [space, setSpace] = useState(
    props.spaceEntity ? props.spaceEntity : emptySpace
  );

  useEffect(() => {
    if (props.spaceEntity) setSpace(props.spaceEntity);
  }, [props.spaceEntity]);

  return (
    <Indent>
      <Input
        title={"Option Name"}
        description="eg. Private Room, Full Bar"
        value={space.name}
        onChange={value => {
          setSpace(s => ({
            ...s,
            name: value
          }));
        }}
      />
      <Input
        icon={<GuestsIcon size={14} color={colors.gray} />}
        title={"Capacity"}
        description="Maximum number of people space can hold"
        value={String(space.capacity)}
        type="number"
        onChange={value => {
          setSpace(s => ({
            ...s,
            capacity: Number(value)
          }));
        }}
      />
      <CostInput
        title={"Starting Cost"}
        type="SPACE"
        description="Base price for this space"
        value={space.startingCost}
        onChange={value => {
          setSpace(s => ({
            ...s,
            startingCost: value
          }));
        }}
      />
      <MultiSelectInput
        title="Space Features"
        name="new-venue-space-features"
        options={VenueFeatures}
        value={space.features}
        onChange={value =>
          setSpace(s => ({
            ...s,
            features: value
          }))
        }
      />
      <Input
        title={"Description"}
        value={space.description}
        multiline={true}
        onChange={value => {
          setSpace(s => ({
            ...s,
            description: value
          }));
        }}
      />
      <Buttons>
        <OutlineButton
          title="Save"
          style={{ marginRight: 10 }}
          onClick={() => {
            setSpace(emptySpace);
            props.onSave(space);
          }}
        />
        <OutlineButton
          title="Cancel"
          color="gray"
          onClick={() => {
            setSpace(emptySpace);
            props.onCancel();
          }}
        />
      </Buttons>
    </Indent>
  );
};

export default EditSpace;
